import { render } from "./topup-verify-pop-up.vue?vue&type=template&id=52ac6a00&ts=true"
import script from "./topup-verify-pop-up.vue?vue&type=script&lang=ts"
export * from "./topup-verify-pop-up.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__